import { forwardRef } from 'react';
import styles from '../sass/components/Alert.module.scss';

export interface AlertProps {
  message?: string;
  type?: string;
  /**
   * `alert` for a form-level message that must be read out the moment it
   * appears (a failed log in, a request that could not be sent). A field's
   * own error sits in TextInput's polite live region instead.
   */
  role?: 'alert' | 'status';
  id?: string;
}

const Alert = forwardRef<HTMLInputElement | null, AlertProps>((
  props,
) => {
  const {
    message, type, role, id,
  } = props;

  return message ? (
    <div className={`${styles.alert} ${type}`} role={role} id={id}>
      {message}
    </div>
  ) : null;
});

export default Alert;
